export interface VideoItem {
  id: number;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  categoryLabel: string;
  thumbnail: string;
  description: string;
  rating: number;
  year: number;
  duration: string;
  tags: string[];
  director: string;
  actors: string[];
  updateInfo: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  episodes?: string;
  featured?: boolean;
}

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    categoryLabel: '电影',
    thumbnail: '',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，人类将面临前所未有的挑战与抉择。这是一场关乎全人类命运的宏大冒险，也是一段感人至深的亲情故事。',
    rating: 8.9,
    year: 2026,
    duration: '148分钟',
    tags: ['科幻', '冒险', '灾难', '国产'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    updateInfo: '2026-07-30',
    views: 2850000,
    isHot: true,
    isNew: false,
    featured: true,
  },
  {
    id: 2,
    title: '长安三万里2',
    category: 'movie',
    categoryLabel: '电影',
    thumbnail: '',
    description: '安史之乱后，大唐由盛转衰。诗人高适被困孤城，回忆起与李白相识相知的一生。在这段跨越数十年的友情中，他们共同见证了长安的繁华与落寞，也留下了千古传颂的诗篇。',
    rating: 8.6,
    year: 2025,
    duration: '168分钟',
    tags: ['动画', '历史', '文学', '国产'],
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    updateInfo: '2025-12-20',
    views: 1920000,
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '封神第二部：战火西岐',
    category: 'movie',
    categoryLabel: '电影',
    thumbnail: '',
    description: '殷商大军兵临西岐城下，姜子牙率领众将士誓死守卫。姬发在战火中逐渐成长，从一名少年蜕变为真正的王者。神仙斗法，人魔大战，一场史诗级的对决即将拉开帷幕。',
    rating: 8.4,
    year: 2025,
    duration: '155分钟',
    tags: ['奇幻', '古装', '战争', '国产'],
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    updateInfo: '2025-08-15',
    views: 3200000,
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '飞驰人生3',
    category: 'movie',
    categoryLabel: '电影',
    thumbnail: '',
    description: '曾经的赛车冠军张驰在经历人生低谷后，决定重返赛场。这一次，他不仅要面对更强大的对手，还要克服年龄和伤病的困扰。在好友和家人的支持下，他能否再次创造奇迹？',
    rating: 8.2,
    year: 2026,
    duration: '135分钟',
    tags: ['喜剧', '运动', '励志', '国产'],
    director: '韩寒',
    actors: ['沈腾', '尹正', '黄景瑜'],
    updateInfo: '2026-02-10',
    views: 4100000,
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '满江红2',
    category: 'movie',
    categoryLabel: '电影',
    thumbnail: '',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇的凶案牵扯出惊天阴谋，小兵张大与亲兵营副统领孙均被迫卷入其中，在有限的时间内寻找真相。',
    rating: 8.0,
    year: 2025,
    duration: '142分钟',
    tags: ['悬疑', '古装', '喜剧', '国产'],
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    updateInfo: '2025-05-01',
    views: 5600000,
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '熊出没·逆转时空',
    category: 'movie',
    categoryLabel: '电影',
    thumbnail: '',
    description: '光头强和熊大熊二意外穿越到未来世界，发现地球已被机器人统治。为了回到过去改变历史，他们必须在充满危险的未来都市中展开一场惊心动魄的冒险。',
    rating: 8.3,
    year: 2026,
    duration: '102分钟',
    tags: ['动画', '喜剧', '冒险', '国产'],
    director: '林永长',
    actors: ['张伟', '张秉君', '谭笑'],
    updateInfo: '2026-01-22',
    views: 1800000,
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: '狂飙',
    category: 'tv',
    categoryLabel: '电视剧',
    thumbnail: '',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开了长达二十年的正邪较量。该剧展现了中国扫黑除恶斗争的艰辛历程，以及正义最终战胜邪恶的坚定信念。',
    rating: 9.1,
    year: 2023,
    duration: '39集',
    tags: ['剧情', '犯罪', '国产', '热播'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    updateInfo: '全39集',
    views: 8500000,
    isHot: true,
    isNew: false,
    episodes: '全39集',
    featured: true,
  },
  {
    id: 8,
    title: '庆余年第二季',
    category: 'tv',
    categoryLabel: '电视剧',
    thumbnail: '',
    description: '范闲从北齐归来后，发现京都暗流涌动。太子与二皇子之争愈演愈烈，庆帝的心思愈发难测。在这权力的漩涡中，范闲必须步步为营，揭开自己身世之谜的同时守护心中所爱。',
    rating: 8.8,
    year: 2024,
    duration: '36集',
    tags: ['古装', '权谋', '剧情', '国产'],
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    updateInfo: '全36集',
    views: 12000000,
    isHot: true,
    isNew: false,
    episodes: '全36集',
  },
  {
    id: 9,
    title: '三体',
    category: 'tv',
    categoryLabel: '电视剧',
    thumbnail: '',
    description: '纳米科学家汪淼被警官史强带到了联合作战中心，并潜入神秘组织"科学边界"。在调查过程中，汪淼接触到了一个名为"三体"的虚拟现实游戏，从而揭开了地球文明与三体文明之间博弈的序幕。',
    rating: 8.7,
    year: 2023,
    duration: '30集',
    tags: ['科幻', '悬疑', '国产', '热播'],
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    updateInfo: '全30集',
    views: 7500000,
    isHot: false,
    isNew: false,
    episodes: '全30集',
  },
  {
    id: 10,
    title: '长相思',
    category: 'tv',
    categoryLabel: '电视剧',
    thumbnail: '',
    description: '上古时期，人神妖混居。皓翎国王姬玖瑶（小夭）流落大荒百年，历经磨难。在清水镇，她化名玟小六，遇到了玱玹、涂山璟、相柳、赤水丰隆等人，一段跨越千年的爱恨纠葛就此展开。',
    rating: 8.5,
    year: 2023,
    duration: '39集',
    tags: ['古装', '爱情', '奇幻', '国产'],
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为'],
    updateInfo: '全39集',
    views: 6800000,
    isHot: false,
    isNew: false,
    episodes: '全39集',
  },
  {
    id: 11,
    title: '玫瑰的故事',
    category: 'tv',
    categoryLabel: '电视剧',
    thumbnail: '',
    description: '出生于书香世家的黄亦玫，从小在呵护中长大。进入职场后，她凭借出色的能力和独特的魅力脱颖而出。在经历了多段感情后，她逐渐明白了真正的爱情和自我价值。',
    rating: 8.4,
    year: 2024,
    duration: '38集',
    tags: ['都市', '爱情', '职场', '国产'],
    director: '汪俊',
    actors: ['刘亦菲', '佟大为', '林更新'],
    updateInfo: '全38集',
    views: 5200000,
    isHot: false,
    isNew: true,
    episodes: '全38集',
  },
  {
    id: 12,
    title: '大奉打更人',
    category: 'tv',
    categoryLabel: '电视剧',
    thumbnail: '',
    description: '现代人杨凌意外穿越到妖魔横行的大奉王朝，成为了一名小小的打更人。在这个充满危险的世界里，他凭借现代知识和机智头脑，一步步揭开朝廷的惊天阴谋。',
    rating: 8.3,
    year: 2025,
    duration: '40集',
    tags: ['古装', '奇幻', '喜剧', '国产'],
    director: '邓科',
    actors: ['王鹤棣', '田曦薇', '刘奕君'],
    updateInfo: '更新至32集',
    views: 4200000,
    isHot: true,
    isNew: true,
    episodes: '更新至32集',
  },
  {
    id: 13,
    title: '奔跑吧·生态篇',
    category: 'variety',
    categoryLabel: '综艺',
    thumbnail: '',
    description: '《奔跑吧》最新生态主题季，跑男团成员们走进中国各地的自然保护区，通过趣味游戏和挑战任务，向观众展示中国生态文明建设的成果，传递环保理念。',
    rating: 8.0,
    year: 2026,
    duration: '90分钟/期',
    tags: ['真人秀', '户外', '搞笑', '环保'],
    director: '姚译添',
    actors: ['李晨', '郑恺', '白鹿', '周深', '范丞丞'],
    updateInfo: '更新至第8期',
    views: 3500000,
    isHot: true,
    isNew: true,
    episodes: '更新至第8期',
  },
  {
    id: 14,
    title: '歌手2026',
    category: 'variety',
    categoryLabel: '综艺',
    thumbnail: '',
    description: '华语乐坛顶级歌手同台竞技，以音乐为武器，用歌声传递情感。全新赛制升级，更多惊喜嘉宾加盟，每一期都是一场视听盛宴，见证歌王的诞生。',
    rating: 8.6,
    year: 2026,
    duration: '120分钟/期',
    tags: ['音乐', '竞技', '真人秀', '热播'],
    director: '洪涛',
    actors: ['那英', '华晨宇', '周深', '毛不易'],
    updateInfo: '更新至第10期',
    views: 6200000,
    isHot: true,
    isNew: false,
    episodes: '更新至第10期',
    featured: true,
  },
  {
    id: 15,
    title: '向往的生活·山海篇',
    category: 'variety',
    categoryLabel: '综艺',
    thumbnail: '',
    description: '黄磊和何炅带领新老朋友们来到海边渔村，开启"山海之间"的田园生活。捕鱼、种菜、做饭、聊天，在慢节奏中感受生活的美好和友情的温暖。',
    rating: 8.2,
    year: 2025,
    duration: '100分钟/期',
    tags: ['生活', '慢综艺', '美食', '治愈'],
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    updateInfo: '全12期',
    views: 4800000,
    isHot: false,
    isNew: false,
    episodes: '全12期',
  },
  {
    id: 16,
    title: '一年一度喜剧大赛3',
    category: 'variety',
    categoryLabel: '综艺',
    thumbnail: '',
    description: '新一季喜剧大赛重磅回归！更多优秀的喜剧演员和编剧带来全新的原创作品，从素描喜剧到音乐喜剧，从默剧到漫才，各种喜剧形式轮番上演，笑点不断。',
    rating: 8.4,
    year: 2026,
    duration: '110分钟/期',
    tags: ['喜剧', '竞演', '原创', '搞笑'],
    director: '马东',
    actors: ['马东', '黄渤', '于和伟', '徐峥'],
    updateInfo: '更新至第6期',
    views: 2800000,
    isHot: false,
    isNew: true,
    episodes: '更新至第6期',
  },
];

export const categories = [
  { slug: 'movie', label: '电影', icon: 'ri-movie-2-line' },
  { slug: 'tv', label: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', label: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', label: '动漫', icon: 'ri-ghost-smile-line' },
];

export const aboutInfo = {
  brandName: '91视频',
  founded: '2018年',
  description: '91视频是国内领先的免费在线视频平台，致力于为全球华人用户提供最优质的视频内容服务。自2018年创立以来，我们始终坚持"免费、高清、丰富"的服务理念，汇聚海量电影、电视剧、综艺、动漫等视频资源，让每一位用户都能轻松享受高质量的视听体验。',
  vision: '成为全球华人首选的在线视频平台，让优质内容触手可及。',
  mission: '通过技术创新和内容聚合，为用户提供免费、高清、流畅的视频观看服务。',
  advantages: [
    { title: '海量资源', description: '收录超过10万部电影、电视剧、综艺节目，每日更新最新内容，涵盖国内外各类热门作品。', icon: 'ri-database-2-line' },
    { title: '高清画质', description: '支持1080P超清画质播放，采用先进的视频压缩技术，在保证画质的同时确保流畅播放。', icon: 'ri-4k-line' },
    { title: '免费观看', description: '所有视频内容完全免费，无需注册会员，无需付费订阅，打开即可观看，真正实现零门槛。', icon: 'ri-vip-crown-line' },
    { title: '多端适配', description: '完美适配电脑、平板、手机等各类设备，随时随地享受视频娱乐，画质和体验不打折。', icon: 'ri-smartphone-line' },
    { title: '智能推荐', description: '基于AI算法的智能推荐系统，根据您的观看偏好精准推送内容，发现更多您可能喜欢的视频。', icon: 'ri-brain-line' },
    { title: '安全可靠', description: '严格遵守相关法律法规，采用先进的内容审核机制，为您提供安全、健康的视频观看环境。', icon: 'ri-shield-check-line' },
  ],
  contact: {
    email: 'contact@91video.com',
    phone: '400-123-4567',
    address: '北京市朝阳区望京科技园A座',
    wechat: '91video_official',
    weibo: '@91视频官方',
  },
  faqs: [
    { question: '91视频网站需要付费吗？', answer: '完全不需要！91视频网站上的所有电影、电视剧、综艺节目均免费观看，无需任何付费会员。我们坚持免费服务理念，让每一位用户都能畅享高质量视频内容。' },
    { question: '如何提高视频播放的清晰度？', answer: '在视频播放页面，您可以点击播放器右下角的"画质"按钮，选择1080P超清画质。如果网络状况良好，系统会自动为您切换至最佳画质。建议在Wi-Fi环境下观看以获得最佳体验。' },
    { question: '视频加载缓慢怎么办？', answer: '首先请检查您的网络连接是否正常。如果网络正常但加载缓慢，可以尝试切换至较低画质（如720P或480P），或暂停视频等待缓冲。如问题持续，可能是服务器高峰期，请稍后再试。' },
    { question: '支持哪些设备观看？', answer: '91视频网站完美适配电脑（Windows/Mac）、平板（iPad/Android Pad）、手机（iPhone/Android手机）等各类设备。只需使用浏览器访问我们的网站即可，无需下载任何APP。' },
    { question: '可以下载视频到本地吗？', answer: '为了尊重版权和遵守相关法律法规，91视频网站目前不支持视频下载功能。您可以通过浏览器在线观看所有内容，我们提供流畅的在线播放体验。' },
    { question: '如何向我们反馈问题或建议？', answer: '您可以通过以下方式联系我们：发送邮件至 contact@91video.com，或关注我们的微信公众号"91video_official"留言。我们非常重视每一位用户的反馈，会在24小时内回复。' },
    { question: '网站内容多久更新一次？', answer: '我们每天都会更新最新内容！电影、电视剧和综艺节目通常在上线后24小时内同步更新。您可以关注网站首页的"最新上线"区域，或使用搜索功能查找您想看的内容。' },
  ],
};